import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ownerDetailView__content" }
const _hoisted_2 = { class: "break-word" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("确定要 "),
  /*#__PURE__*/_createElementVNode("b", null, "移除"),
  /*#__PURE__*/_createTextVNode(" 该成员?")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "text-error"
}, "移除", -1)
const _hoisted_6 = {
  key: 1,
  class: "fl-row"
}
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_change_owner_modal = _resolveComponent("change-owner-modal")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "utils__pageContainer ownerDetailView__wrap" }, {
    title: _withCtx(() => [
      _createVNode(_component_router_link, {
        class: "link-goback",
        to: {name: 'role.list'}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_app_icon, { type: "arrow-left" })
        ]),
        _: 1
      }, 8, ["to"]),
      _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_app_table, {
          ref: "tableRef",
          size: "default",
          "row-key": "roleId",
          columns: _ctx.tableColumns,
          data: _ctx.loadData,
          "show-pagination": true
        }, {
          allDepartmentName: _withCtx(({ record }) => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(record.allDepartmentName), 1)
          ]),
          action: _withCtx(({ record }) => [
            (_ctx.roleDetail.roleName === '部门主管')
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                  _createVNode(_component_a_popconfirm, {
                    placement: "top",
                    onConfirm: ($event: any) => (_ctx.onRemove([record.roleRelId]))
                  }, {
                    title: _withCtx(() => [
                      _hoisted_4
                    ]),
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: ($event: any) => (_ctx.onChangeOwner(record))
                  }, "移交初始管理员", 8, _hoisted_7)
                ]))
          ]),
          _: 1
        }, 8, ["columns", "data"]),
        _createVNode(_component_change_owner_modal, {
          ref: "changeOwnerRef",
          onComplete: _ctx.loadData
        }, null, 8, ["onComplete"])
      ])
    ]),
    _: 1
  }))
}